import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { EventType } from '../../services/Types';
import { BadgeEventTitle } from '../BadgeEventTitle/BadgeEventTitle';
import { isPodcastEnabled } from '../../config/featureFlags';

interface EventTypeToggleProps {
  eventTypesChosen: string[];
  onChange: (event: React.MouseEvent<HTMLElement>, newTypes: string[]) => void;
}

export const EventTypeToggle: React.FC<EventTypeToggleProps> = ({
  eventTypesChosen,
  onChange
}) => {
  return (
    <ToggleButtonGroup
      value={eventTypesChosen}
      onChange={onChange}
      aria-label="event type selection"
    >
      <ToggleButton key='all' value='all' aria-label='all'>
        All
      </ToggleButton>
      {Object.values(EventType)
        .filter(eventType => eventType !== EventType.SERIES)
        .filter(eventType => isPodcastEnabled || eventType !== EventType.PODCAST)
        .map((eventType) => (
        <ToggleButton key={eventType} value={eventType} aria-label={eventType}>
          <BadgeEventTitle eventType={eventType} eventTitle={eventType} />
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};